/**
 * Shared utilities for SMSWiser campaign workspace
 * For Media Devoted | Created By Ciro Autiero
 */

export function unwrapApiData<T>(payload: unknown): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return (payload as { data: T }).data;
  }
  return payload as T;
}
